// extracted by mini-css-extract-plugin
module.exports = {"seoNav":"_17353e7","seoItem":"_8002de3"};